paf-result-legend-item {
  @include host-component-properties-without-host;

  --paf-result-legend-item-gap: 8;
  --paf-result-legend-item-height: 24;
  --paf-result-legend-item-margin-block: 16;
  --paf-result-legend-item-color-color: var(--paf-global-post-brand-black);
  --paf-result-legend-item-transition-duration: 120ms;
  --paf-result-legend-item-hover-color: var(--paf-global-post-brand-dark);
  --paf-result-legend-item-attribute-icon-width: 24;
  --paf-result-legend-item-cus-him-icon-negative-margin: 0;
  --paf-result-legend-item-wheelchair-icon-negative-margin: 0;

  @include mq($to: small) {
    --paf-result-legend-item-cus-him-icon-negative-margin: 2;
    --paf-result-legend-item-wheelchair-icon-negative-margin: 1;
  }
}

.list-item {
  list-style-type: none;
  display: flex;
  align-items: center;
  column-gap: px-to-rem(var(--paf-result-legend-item-gap));
  min-height: px-to-rem(var(--paf-result-legend-item-height));
  font-family: var(--paf-global-font-family);
  margin-block-end: px-to-rem(var(--paf-result-legend-item-margin-block));

  &:last-of-type {
    margin-block-end: 0;
  }

  .content {
    * {
      color: var(--paf-result-legend-item-color-color);
    }

    a {
      transition: color var(--paf-result-legend-item-transition-duration) ease-in;

      @include hover-style {
        color: var(--paf-result-legend-item-hover-color);
      }
    }
  }
}

.list-item--wheelchair {
  align-items: unset;

  span {
    font-weight: var(--paf-global-font-weight-light);
  }

  paf-icon {
    margin-block-start: px-to-rem(calc(-1 * var(--paf-result-legend-item-wheelchair-icon-negative-margin)));

    @include forced-colors-dark {
      filter: invert(1);
    }
  }

  &[role="listitem"] paf-icon {
    --paf-result-legend-item-wheelchair-icon-negative-margin: 3;
  }
}

.list-item[render-without-role="true"] {
  paf-icon {
    align-self: flex-start;
  }
}

.list-item--cus-him-l2 {
  align-items: unset;

  paf-icon {
    margin-block-start: px-to-rem(calc(-1 * var(--paf-result-legend-item-cus-him-icon-negative-margin)));
  }
}

.list-item--attribute {
  paf-icon {
    display: flex;
    justify-content: center;
    flex-basis: var(--paf-result-legend-item-attribute-icon-width);

    --paf-icon-width: var(--paf-result-legend-item-attribute-icon-width);
  }
}
